import { FilterOutlined } from '@ant-design/icons';
import { Badge, Popover, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import { APIState } from '../../../../models/APIState';
import { useResourceMapperStore } from '../../store/useResourceMapperStore';
import { DateRange, OperationType } from '../../types';
import UnmappedResourceFilters from './UnmappedResourceFilters';

const UnmappedResourceFiltersButton = () => {
  const { t } = useTranslation();
  const { filtersState, getAreFiltersApplied, unmappedResourcesStatus } = useResourceMapperStore();
  const [isTankMixShown, setIsTankMixShown] = useState<boolean>(filtersState.isTankMixShown);
  const [dateRange, setDateRange] = useState<DateRange>(filtersState.dateRange);
  const [operationType, setOperationType] = useState<OperationType>(filtersState.operationType);
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const [isTooltipShown, setIsTooltipShown] = useState<boolean>(false);
  const isLoading = unmappedResourcesStatus === APIState.LOADING;

  const handlePopoverOpenChange = (newOpenStatus: boolean) => {
    setIsPopoverOpen(newOpenStatus);
    if (!newOpenStatus) {
      resetFiltersToPrevious();
    }
  };

  const handleTooltipOpenChange = (newOpenStatus: boolean) => {
    if (!isPopoverOpen) {
      setIsTooltipShown(newOpenStatus);
    }
  };

  const resetFiltersToPrevious = () => {
    setIsTankMixShown(filtersState.isTankMixShown);
    setDateRange(filtersState.dateRange);
    setOperationType(filtersState.operationType);
  };

  useEffect(() => {
    if (isPopoverOpen) {
      setIsTooltipShown(false);
    }
  }, [isPopoverOpen]);

  return (
    <div className={'unmapped-resource-filters'}>
      <Popover
        placement="rightTop"
        trigger="click"
        content={
          <UnmappedResourceFilters
            closeModal={() => setIsPopoverOpen(false)}
            filters={{
              isTankMixShown: { value: isTankMixShown, update: setIsTankMixShown },
              dateRange: { value: dateRange, update: setDateRange },
              operationType: { value: operationType, update: setOperationType },
            }}
          />
        }
        open={isPopoverOpen}
        onOpenChange={handlePopoverOpenChange}
      >
        <Tooltip
          title={t('resource-mapper.filter-tooltip')}
          open={isTooltipShown}
          onOpenChange={handleTooltipOpenChange}
        >
          <Button
            className="h-[40px] min-w-[40px] w-[40px] disabled:border-neutral-30"
            icon={
              <Badge
                offset={[0, 5]}
                dot={getAreFiltersApplied()}
                color="blue"
                data-testid="filter-badge"
              >
                <FilterOutlined />
              </Badge>
            }
            type={ButtonType.outline}
            data-testid="filter-button"
            disabled={isLoading}
          />
        </Tooltip>
      </Popover>
    </div>
  );
};

export default UnmappedResourceFiltersButton;
